<template src='./NewsVerticalCard.html'></template>

<script>
export default {
  name: "news-vertical-card",
  props: {
    id: { type: Number },
    name: { type: String },
    date: { type: String },
    description: { type: String },
    image: { type: String },
    descriptionImg: { type: String, default: "Imagen de la noticia" },
    buttonText: { type: String },
  },
  data() {
    return {
      disableButton: "",
    };
  },
  computed: {
    imgUrl() {
      return this.image
        ? this.image
        : "https://storage.googleapis.com/arroba-downloads/recursos/Img_default.png";
    },
  },
};
</script>

<style lang="scss" scoped src="./NewsVerticalCard.scss"></style>